<template>
  <div
    id="app"
    class="home-default"
    :class="{
      'home-default': themeCode === 'default',
      home: themeCode === 'blue'
    }"
  >
    <div id="outline">
      <div class="outline-header">
        <div class="outline-header-bg">
          <img
            v-if="themeCode === 'default'"
            src="../../../assets/default/headerbg.png"
            alt=""
          />
          <img
            v-else-if="themeCode === 'blue'"
            src="../../../assets/electricity/headerbg.png"
            alt=""
          />
        </div>
        <div class="outline-header-left">
          <div v-if="ImageUrl">
            <img :src="ImageUrl" alt="" />
          </div>
          <div @click="outlineArea = !outlineArea" class="map-left-group-report">{{ headTitle }}</div>
        </div>
        <div class="outline-header-center">
          <div class="outline-header-center-top">
            <img
              :src="
                themeCode === 'default'
                  ? require('../../../assets/default/decorate_left.png')
                  : require('../../../assets/electricity/decorate_left.png')
              "
              alt=""
            />
            <!-- <dv-decoration-1 style="width:200px;height:50px;" /> -->
            <div class="outline-header-center-title">
              <!-- 安全用气预警监控系统 -->
              {{TittleName}}
            </div>
            <!-- <dv-decoration-1 style="width:200px;height:50px; transform: rotateY(180deg);" /> -->
            <img
              :src="
                themeCode === 'default'
                  ? require('../../../assets/default/decorate_rigth.png')
                  : require('../../../assets/electricity/decorate_rigth.png')
              "
              alt=""
            />
          </div>
          <div
            class="outline-header-center-bottom"
            style="letter-spacing: 0px;"
          >
            <!-- Safety gas warning monitoring system -->
            {{TittleNameEN}}
          </div>
        </div>
        <div class="outline-header-right">
          <div @click="goPages" class="map-right-group-report" id="enterSys">{{ $t('bigScreen.index.925365-0') }}</div>
          <img
            style="cursor: pointer"
            @click="goBack"
            :src="
              themeCode === 'default'
                ? require('../../../assets/default/return.png')
                : require('../../../assets/electricity/return.png')
            "
            :alt="$t('bigScreen.index.925365-1')"
          />
        </div>
        <div class="outline-and"></div>
      </div>
      <div id="container" style="width:100%; height:100%"></div>
      <div class="outline-content">
        <div class="outline-left">
          <div class="outline-left-item-top">
            <dv-border-box-4
              :color="[
                themeCode === 'default' ? '#2AEED0' : '#8256F3',
                'rgba(84, 180, 168, .7)'
              ]"
              class="outline-content-border"
              :reverse="true"
            >
              <div class="outline-content-data">
                <dv-scroll-board
                  :config="config"
                  style="width:100%;height:100%"
                />
              </div>
            </dv-border-box-4>
          </div>
          <div class="outline-left-item-bottom">
            <dv-border-box-4
              :color="[
                themeCode === 'default' ? '#2AEED0' : '#8256F3',
                'rgba(84, 180, 168, .7)'
              ]"
              class="outline-content-border"
              :reverse="true"
            >
              <div class="outline-content-data">
                <dv-scroll-board
                  :config="roomConfig"
                  style="width:100%;height:90%"
                />
              </div>
            </dv-border-box-4>
          </div>
        </div>

        <div class="outline-right">
          <div class="outline-right-item-top">
            <dv-border-box-4
              :color="[
                themeCode === 'default' ? '#2AEED0' : '#8256F3',
                'rgba(84, 180, 168, .7)'
              ]"
              class="outline-content-border"
            >
              <div class="outline-content-data">
                <dv-scroll-board
                  :config="devicesConfig"
                  style="width:100%;height:100%"
                />
              </div>
            </dv-border-box-4>
          </div>
          <div class="outline-right-item-bottom">
            <dv-border-box-4
              :color="[
                themeCode === 'default' ? '#2AEED0' : '#8256F3',
                'rgba(84, 180, 168, .7)'
              ]"
              class="outline-content-border"
            >
              <div class="outline-content-data">
                <!-- <div class="outline-right-title">{{ $t('bigScreen.index.925365-18') }}</div> -->
                <div class="outline-right-top-chart">
                  <div
                    id="myChart1"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </div>
            </dv-border-box-4>
          </div>
          <!-- <div class="outline-right-item-fotter">
                <dv-border-box-8 class="outline-content-border">
                    <div class="outline-content-data">
                        {{ $t('bigScreen.index.925365-0') }}
                    </div>
                </dv-border-box-8>
            </div> -->
        </div>
      </div>
      <div class="outline-area" :class="{'hiddenBottom': outlineArea}" style="overflow: auto;">
        <TreeModel type="device" @on-select-change="onSelectChange" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import Cookies from "js-cookie";
import api from "../../../api/request.js";
import TreeModel from "../../useGas/views/area/mods/tree.vue";
export default {
  components: {
    TreeModel
  },
  name: "App",
  data() {
    return {
      cityName: Cookies.get("cityName") || this.$t('bigScreen.index.925365-2'),

      TittleName: "", // 中文title
      TittleNameEN: "", // 英文title
      ImageUrl: "",
      themeCode: "",

      map: null, // 地图

      config: {},
      devicesConfig: {},
      roomConfig: {},

      parameter: "",
      headTitle: this.$t('bigScreen.index.925365-3'),
      outlineArea: false,
      query: {},
      devicesList: [], // 设备
    };
  },
  created() {
    const _this = this;
    _this.themeCode = _this.$store.getters.getThemeCode;
    const { TittleName, TittleNameEN, ImageUrl } = JSON.parse(
      Cookies.get("AdminData")
    );

    _this.TittleName = TittleName;
    _this.TittleNameEN = TittleNameEN;
    _this.ImageUrl = ImageUrl;
  },

  computed: {},

  mounted() {
    let _this = this;

    _this.mapData();

    _this.GetDeviceAbnormalPageListWith3Code();

    _this.GetDeviceZLData();

    _this.GetUserDevicesPage();

    _this.GetRoshRoomList();

    if (this.$driver.isActivated) {
      let steps = [
        {
          element: "#enterSys",
          popover: {
            title: _this.$t('bigScreen.index.925365-4'),
            description: _this.$t('bigScreen.index.925365-5'),
            position: "left",
            className: 'robotLeft'
          }
        },
      ]
      this.$nextTick(() => {
        this.$driver.defineSteps(steps);
        this.$driver.start();
      })
    }
  },
  methods: {
    onSelectChange(item) {
      this.parameter = "";
      this.headTitle = item.title;
      this.query = {};
      switch (item.grade) {
        case 1:
          this.parameter = `&Ccode=${item.Ccode}`;
          this.query = {
              Ccode: item.Ccode
          }
          break;
        case 2:
          this.parameter = `&Vcode=${item.Vcode}`;
          this.query = {
              Vcode: item.Vcode
          }
          break;
        case 3:
          this.parameter = `&Scode=${item.Scode}`;
          this.query = {
              Scode: item.Scode
          }
          break;
        case 4:
          this.parameter = `&Zcode=${item.Zcode}`;
          this.query = {
              Zcode: item.Zcode
          }
          break;
        case 5:
          this.parameter = `&RoomCode=${item.RoomCode}`;
          this.query = {
              Zcode: item.Zcode
          }
          break;
        default:
          break;
      }
      if (item.Jd && item.Wd) {
        this.cityName = item.CityName
      } else {
        this.cityName = Cookies.get("cityName") || this.$t('bigScreen.index.925365-6')
      }
      this.GetDeviceAbnormalPageListWith3Code();
      this.GetDeviceZLData();
      this.GetUserDevicesPage();
      this.GetRoshRoomList();
    },

    // 根据集团 公司 部门获取设备异常（yhj）
    GetDeviceAbnormalPageListWith3Code(type) {
      if (!Cookies.get("AdminData")) {
        if (window.location.host == "xed.hxpwr.com") {
          this.$router.push({
            name: "xed_login"
          });
        } else {
          this.$router.push({
            name: "login"
          });
        }
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get("AdminData"));
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1&isAdmin=${AdminData.IsAdmin}${this.parameter}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token") ? Cookies.get("Token") : ""
          }
        },
        "yhj"
      ).then(function(res) {
        if (res.Success) {
          _this.config = {
            header: [_this.$t('bigScreen.index.925365-7'), _this.$t('bigScreen.index.925365-8'), _this.$t('bigScreen.index.925365-9'), _this.$t('bigScreen.index.925365-10')],
            align: ["center"],
            headerBGC: "rgba(0,0,0,0.12)",
            rowNum: 9,
            columnWidth: [80],
            oddRowBGC:
              _this.themeCode === "default"
                ? "rgba(84, 180, 168, 0.6)"
                : "rgba(16, 37, 98, 0.6)",
            evenRowBGC:
              _this.themeCode === "default"
                ? "rgba(84, 180, 168, 0.2)"
                : "rgba(16, 37, 98, 0.2)",
            data: (res.Data || []).map(item => {
              return [
                _this.intercept(item.AbnormalTime),
                item.DeviceCode,
                item.UserDeviceName,
                item.AbnormalName
              ];
            })
          };
        } else {
          _this.$Message["error"]({
            background: true,
            content: res.Message
          });
        }
      });
    },

    // 图表在线离线数据（yhj）
    GetDeviceZLData() {
      if (!Cookies.get("AdminData")) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get("AdminData"));
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `api/CommElecDevice/GetDeviceZLData?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&isAdmin=${AdminData.IsAdmin}${this.parameter}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token")
          }
        },
        "yhj"
      )
        .then(function(res) {
          if (res.Success) {
            let series = [];
            res.Data.forEach((item, index) => {
              series.push({
                value: item.value,
                name: item.name,
                itemStyle: {
                  color: index === 0 ? "#8256F3" : "#2AEED0"
                }
              });
            });
            _this.$nextTick(function() {
              _this.myChart1(series);
            });
          } else {
            _this.$Message["error"]({
              background: true,
              content: res.Message
            });
          }
        })
        .catch(function(err) {
          // if (err.data.Code == -9 || err.data.Code == -1) {
          // 	_this.$router.push({
          // 		name: 'login'
          // 	})
          // }
        });
    },

    // 根据集团 公司 部门编号 等条件查询设备列表
    GetUserDevicesPage() {
      if (!Cookies.get("AdminData")) {
        return;
      }

      let _this = this,
        AdminData = JSON.parse(Cookies.get("AdminData"));
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `api/CommElecDevice/GetUserDevicesPageV2?groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=1&pageSize=100${this.parameter}&deviceType=qg`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token")
          }
        },
        "yhj"
      )
        .then(function(res) {
          if (res.Success) {
              _this.devicesList = res.Data || []
              _this.initMapData();
            _this.devicesConfig = {
              header: [_this.$t('bigScreen.index.925365-8'), _this.$t('bigScreen.index.925365-9'), _this.$t('bigScreen.index.925365-11'), _this.$t('bigScreen.index.925365-12')],
              align: ["center"],
              headerBGC: "rgba(0,0,0,0.12)",
              rowNum: 7,
              oddRowBGC:
                _this.themeCode === "default"
                  ? "rgba(84, 180, 168, 0.6)"
                  : "rgba(16, 37, 98, 0.6)",
              evenRowBGC:
                _this.themeCode === "default"
                  ? "rgba(84, 180, 168, 0.2)"
                  : "rgba(16, 37, 98, 0.2)",
              data: (res.Data || []).map(item => {
                return [
                  item.DeviceCode,
                  item.UserDeviceName,
                  item.IsOnline ? _this.$t('bigScreen.index.925365-13') : _this.$t('bigScreen.index.925365-14'),
                  item.Address
                ];
              })
            };
          } else {
            _this.$Message["error"]({
              background: true,
              content: res.Message
            });
          }
        })
        .catch(function(err) {});
    },

    GetRoshRoomList() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: `api/User/GetRoshRoomList`,
        data: {
            ...this.query
        },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.roomConfig = {
              header: [this.$t('bigScreen.index.925365-15'), this.$t('bigScreen.index.925365-16'), this.$t('bigScreen.index.925365-17')],
              align: ["center"],
              headerBGC: "rgba(0,0,0,0.12)",
              rowNum: 4,
              oddRowBGC:
                this.themeCode === "default"
                  ? "rgba(84, 180, 168, 0.6)"
                  : "rgba(16, 37, 98, 0.6)",
              evenRowBGC:
                this.themeCode === "default"
                  ? "rgba(84, 180, 168, 0.2)"
                  : "rgba(16, 37, 98, 0.2)",
              data: (res.Data || []).map(item => {
                return [
                  item.RoomName || '-',
                  item.OwnerPhone || '-',
                  item.OrganizationName || '-'
                ];
              })
            };
        }
      });
    },

    myChart1(series) {
      let _this = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("myChart1"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [
          {
            name: _this.$t('bigScreen.index.925365-18'),
            type: "pie",
            radius: ["40%", "60%"],
            label: {
              formatter: "{b}: {c} ({d}%)"
            },
            data: series
          }
        ]
      });

      window.addEventListener("resize", function() {
        myChart.resize();
      });

      // 饼图点击跳转到指定页面
      myChart.on("click", function(param) {
        //   _this.openPopup(2, param.name == this.$t('bigScreen.index.925365-13') ? '设备在线列表' : '设备离线列表', param.name == this.$t('bigScreen.index.925365-13') ? '1' : '0')
      });
    },

    intercept(value) {
      if (!value) return "";
      return value.slice(11, 19);
    },

    // 地图
    mapData() {
      let _this = this;
      // 百度地图API功能
      _this.map = new BMap.Map("container", {
        mapType: BMAP_HYBRID_MAP
      }); // 创建Map实例
      // var cityName = _this.cityName;
      // _this.map.centerAndZoom(cityName, 12); // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
      // map.addControl(new BMap.OverviewMapControl());              //添加缩略地图控件
      //添加地图类型控件
      _this.map.addControl(
        new BMap.MapTypeControl({
          offset: new BMap.Size(470, 87),
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
        })
      );
      _this.map.centerAndZoom(new BMap.Point(120.58, 28.08), 8);
      _this.map.enableScrollWheelZoom();
      _this.map.disableDoubleClickZoom();
    },

    // 获取区域列表展示地图信息
    initMapData() {
      let _this = this;
      var mapPoints = _this.devicesList;

      var i = 0;

      var changeIcon1 = new BMap.Icon(
        require("../../../assets/electricity/greenmaker1.png"),
        new BMap.Size(100, 100)
      );
      var changeIcon2 = new BMap.Icon(
        require("../../../assets/electricity/greenmaker1.png"),
        new BMap.Size(100, 100)
      );
      var changeIcon3 = new BMap.Icon(
        require("../../../assets/electricity/greenmaker1.png"),
        new BMap.Size(100, 100)
      );
      _this.map.clearOverlays(); //清除地图覆盖物

      for (let i = 0; i < mapPoints.length; i++) {
        var points = new BMap.Point(mapPoints[i].Longitude, mapPoints[i].Latitude); //创建坐标点
        var opts = {
          width: 400,
          height: 200,
          title: mapPoints[i].UserDeviceName
        };
        var label = new BMap.Label(mapPoints[i].UserDeviceName, {
          offset: new BMap.Size(25, 5)
        });

        label.setStyle({
          color: "#ffffff",
          fontSize: "0.6vw",
          height: "1.5vw",
          padding: "0 0.5vw",
          marginTop: "-0.5vw",
          borderRadius: "0.25vw",
          border: "0.05vw solid rgba(15,72,151,0.7)",
          backgroundColor: "rgba(15,72,151,0.7)",
          marginLeft: "0.5vw",
          lineHeight: "1.35vw",
          fontFamily: _this.$t('bigScreen.index.925365-19')
        });

        _this.markerFun(points, label, null, changeIcon1, mapPoints[i]);
      }
    },

    markerFun(points, label, infoWindows, ico, data) {
      let _this = this;
      var markers = new BMap.Marker(points, {
        icon: ico
      });

      _this.map.addOverlay(markers);
      markers.setLabel(label);
    },

    goBack() {
      if(this.$route.query.flag) {
					console.log(this.$route.query.flag,88);
					this.$router.push({
						name: 'homebak1'
					})
				}else {
					console.log(111);
					this.$router.push({
						name: 'home'
					});
				}
    },
    goPages() {
      this.$router.push({
        name: "useGas"
      });
    }
  }
};
</script>
<style scoped="scoped" lang="scss">
@import "./big_screen_default.scss";
@import "./big_screen.scss";
</style>



// WEBPACK FOOTER //
// src/components/useGas/bigScreen/index.vue